export default "__VITE_ASSET__8941e240__"